import { debounce as _debounce } from 'lodash';

import listPrescriptionFills from './listPrescriptionFills';

const listPrescriptionFillsDebounce = _debounce(listPrescriptionFills, 350);

export default listPrescriptionFillsDebounce;
